import { bg } from "styles/theme"
import { useContext } from "react"
import { TableContext } from "../TableContext"
import { Button, IconButton } from "components/Form"
import { Done, Search } from "@mui/icons-material"
import { useQueryClient } from "@tanstack/react-query"

const useSearchFilter = () => {
    const { searchVal, setSearchVal, queryKey } = useContext(TableContext)

    const queryClient = useQueryClient()

    const handleSearch = () => {
        queryClient.invalidateQueries({ queryKey: queryKey })
    }

    const search = {
        placeholder: "",
        input: {
            value: searchVal,
            onChange: setSearchVal
        },
        // endAdornment: {
        //     component: () =>
        //         <Button
        //             disabled={!searchVal}
        //             size="small"
        //             color="thirdly"
        //             label="חפש"
        //             disabledColor="thirdly"
        //             action={handleSearch}
        //         />
        // },
        startAdornment: {
            component: () => <Search />
        },
        bg: bg,
        onKeyDown: (event) => {
            if (event.key === 'Enter')
                handleSearch()
        }
    }

    return search
}

export default useSearchFilter